import { DialogContent, DialogRoot } from '@/components/ui/Dialog'
import type { RankingOut } from '@/api/endpoints/ranking'
import {
  RankingBreakdownView,
  type RankingBreakdownTab,
} from '@/features/ranking/components/RankingBreakdownView'

export interface RankingBreakdownModalProps {
  open: boolean
  initialTab: RankingBreakdownTab
  ranking: RankingOut
  onClose: () => void
}

/**
 * Modal wrapper around the shared RankingBreakdownView. Used by the
 * project-page RankingDock — clicking any of the four metric cards opens
 * this dialog already pinned to the matching tab, while still allowing
 * the user to switch to other tabs without dismissing.
 */
export function RankingBreakdownModal({
  open,
  initialTab,
  ranking,
  onClose,
}: RankingBreakdownModalProps) {
  return (
    <DialogRoot
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose()
      }}
    >
      <DialogContent
        title="Detalhamento do ranking"
        description={`Critérios ${ranking.criteria_version} · ${ranking.factory} · ${ranking.language}`}
      >
        <RankingBreakdownView ranking={ranking} initialTab={initialTab} />
      </DialogContent>
    </DialogRoot>
  )
}
